export default __webpack_public_path__ + "static/media/logo_brown_text.1faca350.svg";